import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

/**
 * Extract dates from pasted Eltern-Mail text (sync).
 * @param {string} text
 */
export async function submitPastedMail(text) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }

  const res = await fetch(`${API_BASE}/api/mail-paste`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ text }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Auswertung fehlgeschlagen (${res.status}).`);
  }
  return data;
}
